import ProdVersion from './send_sms_message_prod';
import NonProdVersion from './send_sms_message';

let component;

if (process.env.REACT_APP_ENV === 'production') {
  component = ProdVersion;
} else {
  component = NonProdVersion;
}
const final_component = component;

export default final_component;
